import { useRef } from 'react';
import { CalendarDaysIcon } from '@heroicons/react/24/outline';

// Native datetime-local always displays in the OS locale, so we keep it
// underneath (transparent) with a dd/mm/yyyy HH:mm label on top. The label is
// pointer-events-none and tapping the wrapper explicitly calls showPicker() on
// the native input — a plain opacity-0 overlay doesn't reliably open the picker
// inside the Capacitor WebView. Value in/out stays 'yyyy-mm-ddTHH:mm'.
function isoToDDMMYYYYHHmm(iso) {
  if (!iso) return '';
  const [datePart, timePart] = iso.split('T');
  const [y, m, d] = (datePart || '').split('-');
  return `${d}/${m}/${y}${timePart ? ` ${timePart}` : ''}`;
}

function DateTimeInput({ value, onChange, min, max }) {
  const ref = useRef(null);
  const open = () => {
    const el = ref.current;
    if (!el) return;
    if (typeof el.showPicker === 'function') {
      try { el.showPicker(); return; } catch (e) { /* fall through to focus */ }
    }
    el.focus();
    el.click();
  };
  return (
    <div className="relative" onClick={open}>
      <input
        ref={ref}
        type="datetime-local"
        value={value || ''}
        onChange={(e) => onChange(e.target.value)}
        min={min || undefined}
        max={max || undefined}
        className="absolute inset-0 z-10 h-10 w-full opacity-0"
      />
      <div className="pointer-events-none flex h-10 w-full items-center justify-between rounded-md border border-gray-300 bg-white px-3 text-sm">
        <span className={value ? 'text-gray-900' : 'text-gray-400'}>
          {value ? isoToDDMMYYYYHHmm(value) : 'dd/mm/yyyy --:--'}
        </span>
        <CalendarDaysIcon className="h-4 w-4 shrink-0 text-gray-400" />
      </div>
    </div>
  );
}

export default DateTimeInput;
